export default __webpack_public_path__ + "static/media/icon-pencil.96d54cb0.svg";